/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ContactTermsPayables } from '@gh/builder-shared-data';
import { ContextRoute, getContextRouteInitData, getContextRouteStaticData } from '@gh/common-internal-shared';
import { EnumDictionary } from '@gh/common-shared';
import { assign } from 'lodash';
import { ContactDetailsFormState } from '../contact-details-tab-container/contact-details-form.service';
import { ContactDetailsSharedTermsPayeeFormState } from './contact-details-shared-terms-payee-form.service';

@Component({
  selector: 'gh-contact-details-shared-terms-payee-tab',
  template: require('./contact-details-shared-terms-payee-tab.component.html'),
})
export class ContactDetailsSharedTermsPayeeTabComponent implements OnInit {
  form: ContactDetailsSharedTermsPayeeFormState;
  termsPayables: EnumDictionary<ContactTermsPayables>;

  constructor(private route: ContextRoute,
              rootForm: ContactDetailsFormState) {
    this.form = <ContactDetailsSharedTermsPayeeFormState>rootForm
      .getChildForm(getContextRouteStaticData(this.route)['tab'])
      .getChildForm('terms');
  }

  get balancePlaceholder(): string {
    switch (this.form.paymentIsDue) {
      case ContactTermsPayables.OnMonthDay:
      case ContactTermsPayables.MonthDayAfterEOM:
        return 'lbl_terms_due_day';
      default:
        return 'lbl_terms_balance_due';
    }
  }

  ngOnInit(): void {
    assign(this, getContextRouteInitData(this.route));
  }

  onPaymentIsDueChange(): void {
    this.form.update();
  }
}
